import { Renderer2, Component, OnInit, Input, Inject, OnChanges } from '@angular/core';
import { GlobalService } from '../../service/global.service';
import { DOCUMENT } from '@angular/common';
import { BaselineInfo } from '../../model/baseline.model';

import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { GoogleChartBaselineTaskInfo } from '../../model/GoogleOrgChartInfo';
import { TokenService } from '../../service/token.service';

@Component({
  selector: 'app-google-bar-chart',
  templateUrl: './google-bar-chart.component.html',
  styleUrls: ['./google-bar-chart.component.css']
})
export class GoogleBarChartComponent implements OnInit {
  @Input() ProjectCode: string;
  baseurl: string;
  arraydata: any
  arraycolor: string[] = [];
  BaselineList: BaselineInfo[]
  Maincolor: string;
  Milestonecolor: string;
  Deliverycolor: string;

  OnTrackcolor: string;
  Atriskcolor: string;
  Delaycolor: string;
  Complatecolor: string;
  CountMilestone: number;
  CountListBarChart: number;

  constructor(@Inject(DOCUMENT) private _document: Document, private renderer2: Renderer2, private httpClient: HttpClient
    , @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    this.Maincolor = '#6ae7d8'; // Base line
    this.Milestonecolor = '#010101';
    this.Deliverycolor = '#a5ceff'; // Delivery Type

    this.OnTrackcolor = '#1e8655';  // <= 30% Green
    this.Atriskcolor = '#f29137';  // > 30% Orang
    this.Delaycolor = '#ff5555';  // > 100% Red
    this.Complatecolor = '#3f51b5';  // Complate

  }

  async ngOnInit() {

    await this.OnloadBaseline(true);
    await this.LoadGoogleBaselineChart();
  }

  async LoadGoogleBaselineChart() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['BaselineProjectCode'] = this.ProjectCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<GoogleChartBaselineTaskInfo[]>(this.baseurl + "Baseline/GetGoogleChartBaselineData", strjson, httpOptions)
        .toPromise().then(data => {
          if (data.length > 0) {

            var arrParent = [];
            arrParent.push(['Task', 'Progress', { role: 'style' }, { role: 'annotation' }]);

            $.each(data, function (i) {
              var item = data[i];
              var tmpArr = [];
              tmpArr.push(item.Task);
              tmpArr.push(item.ProgressValue);
              tmpArr.push(item.Color);
              tmpArr.push(item.Progress)

              arrParent.push(tmpArr);
            });



            this.initialGoogleColumnChartData(arrParent);
          }

          this.CountListBarChart = data.length;
        });
    }
  }

  //Chart zone
  initialGoogleColumnChartData(listData: GoogleChartBaselineTaskInfo[]) {
    var jsCode = `
 
  google.charts.load('current', {packages: ['corechart', 'bar']});
  google.charts.setOnLoadCallback(drawColumnChart);

function drawColumnChart() {
    var jsonStr = `
    jsCode += JSON.stringify(listData);
    jsCode += `
    var data = google.visualization.arrayToDataTable(jsonStr);

     var options = {
        legend: 'none'
      };

      var chart = new google.visualization.ColumnChart(
        document.getElementById('chart_div'));

      chart.draw(data, options);
    }`;

    this.RenderChart(jsCode);
  }
  RenderChart(data: string) {

    let script = this.renderer2.createElement('script');
    script.setAttribute("id", "scriptcolumnchart");
    script.type = 'text/javascript';
    script.text = data;

    this.renderer2.appendChild(this._document.body, script);
  }
  
  OnloadBaseline(flagfirsttime: boolean = true) {
    $('#scriptcolumnchart').remove();
    if (flagfirsttime == true) {
      var css = `<style>.google-visualization-tooltip {
          width: unset !IMPORTANT;
          height: unset !IMPORTANT;
      }</style>`;
      $('body').append(css);
      this.Importjs('https://www.gstatic.com/charts/loader.js');
    }
  }
  Importjs(src: any): void {

    let script = this.renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    this.renderer2.appendChild(this._document.body, script);
  }

}
